import { render } from "./DetailsInput.vue?vue&type=template&id=bb12a67a&scoped=true"
import script from "./DetailsInput.vue?vue&type=script&lang=js"
export * from "./DetailsInput.vue?vue&type=script&lang=js"

import "./DetailsInput.vue?vue&type=style&index=0&id=bb12a67a&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb12a67a"]])

export default __exports__